import { LitElement, html, css } from "lit-element";

// language=CSS
export const StofwareFullscreenSpinerStyle = css`
	:host {
		position: fixed;
		width: 100vw;
		height: 100vh;
		z-index: 9999;
		top: 0;
		right: 0;
		background-color: var(--fullscreen-spinner-bg, rgba(255, 255, 255, 0.57));

		align-items: center;
		justify-content: center;

		transition: visibility 0.1s, opacity 0.1s linear;

		display: -webkit-box;
		display: -moz-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		opacity: 0;
		visibility: hidden;
	}

	:host[active="true"],
	:host([active="true"]),
	:host([active]),
	:host[active] {
		visibility: visible;
		opacity: 1;
	}

	.spinner {
		width: 40px;
		height: 40px;

		position: relative;
	}

	.double-bounce1,
	.double-bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: var(--app-accent, black);
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;

		-webkit-animation: sk-bounce 2s infinite ease-in-out;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.double-bounce2 {
		-webkit-animation-delay: -1s;
		animation-delay: -1s;
	}

	@-webkit-keyframes sk-bounce {
		0%,
		100% {
			-webkit-transform: scale(0);
		}
		50% {
			-webkit-transform: scale(1);
		}
	}

	@keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
			-webkit-transform: scale(0);
		}
		50% {
			transform: scale(1);
			-webkit-transform: scale(1);
		}
	}
`;

export class StofwareFullscreenSpiner extends LitElement {
	static get properties() {
		return {
			active: { type: Boolean }
		};
	}

	static get styles() {
		return StofwareFullscreenSpinerStyle;
	}

	render() {
		return html`
			<div class="spinner">
				<div class="double-bounce1"></div>
				<div class="double-bounce2"></div>
			</div>
		`;
	}
}

customElements.define("sw-fullscreen-spinner", StofwareFullscreenSpiner);
